<template>
  <div style="text-align: center;">
    <h5>查询所有学生信息</h5>
    <h6>总共有{{ totalCount }}人，未查询有{{ unqueriedCount }}人，已查询有{{ queriedCount }}人</h6>
  </div>
  <div>
    <el-table :data="students" style="width: 100%">
      <el-table-column prop="name" label="名字" min-width="120"></el-table-column>
      <el-table-column prop="std_idcard_num" label="身份证号码" min-width="160"></el-table-column>
      <el-table-column prop="preregno" label="预报名号" min-width="140"></el-table-column>
      <el-table-column prop="sit_number" label="座位号" min-width="100"></el-table-column>
      <el-table-column prop="grade" label="年段" min-width="100"></el-table-column>
      <el-table-column prop="class" label="班级" min-width="100"></el-table-column>
      <el-table-column prop="find_number" label="被查询次数" min-width="120"></el-table-column>
    </el-table>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      students: [],
    };
  },
  mounted() {
    this.fetchStudents();
  },
  computed: {
    totalCount() {
      return this.students.length;
    },
    unqueriedCount() {
      return this.students.filter((student) => student.find_number === 0).length;
    },
    queriedCount() {
      return this.students.filter((student) => student.find_number > 0).length;
    },
  },
  methods: {
    async fetchStudents() {
      try {
        const response = await axios.get('/students');
        this.students = response.data;
      } catch (error) {
        console.error('获取学生信息失败:', error);
      }
    },
  },
};
</script>
